import loginModule from './login'

const modules = {
  loginModule
}

export default modules